/*
 * COPYRIGHT 2022,2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

import { Colours, FontFamily } from 'yospace-ui-components';

export class AppStyles {
    static STYLES = Object.freeze({
        main: {
            backgroundColor: Colours.backgroundMain,
            fontFamily: FontFamily.variable,
            width: '100%'
        },
        container: {
            padding: '0px 0px 0px 0px',
            display: 'flex',
            alignItems: 'flex-start',
            width: '100%'
        },
        elementContainer: {
            display: 'inline-block',
            verticalAlign: 'top',
            padding: '0px 0px 0px 0px'
        },
        selectedContainer: {
            display: 'inline-block',
            verticalAlign: 'top',
            width: '100%',
            flex: '1 1 auto',
            overflowX: 'auto'
        }
    });

    static getContainer() {
        return AppStyles.STYLES.container;
    }

    static getElementContainer() {
        return AppStyles.STYLES.elementContainer;
    }

    static getMain() {
        return AppStyles.STYLES.main;
    }

    static getSelectedContainer() {
        return AppStyles.STYLES.selectedContainer;
    }
}

